import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sync-progress"
export default class extends Controller {
  
  // Called when a source form is submitted
  sourceSubmit(event) {
    
    // Get the sync card container
    const syncCard = this.element
    
    // Hide all default containers and show all progress containers
    syncCard.querySelectorAll('.default').forEach(el => {
      el.classList.add('d-none')
    })
    
    syncCard.querySelectorAll('.sync-progress').forEach(el => {
      el.classList.remove('d-none')
    })

  }

  // Called when a target form is submitted
  targetSubmit(event) {
    console.log("Target form submitted, showing progress")
    // Get the sync card container
    const syncCard = this.element
    
    // Hide all default containers and show all progress containers
    syncCard.querySelectorAll('.default').forEach(el => {
      el.classList.add('d-none')
    })
    
    syncCard.querySelectorAll('.sync-progress').forEach(el => {
      el.classList.remove('d-none')
    })

  }
}
